import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { previouslyReviewedIds: Array };

  connect() {}

  checkPreviouslyReviewed(event) {
    if (
      this.previouslyReviewedIdsValue.indexOf(
        parseInt(event.currentTarget.value)
      ) >= 0
    ) {
      //do toast
      //"This song has already been submitted for Review. Request another Review for this song?"
    }
  }

  // only allow 3
  focusArea(event) {
    $("[data-more='true']").prop("checked", true);

    if ($("input.focus_area:checked").length > 3) {
      $(event.currentTarget).prop("checked", false);
    }

    return false;
  }

  // select "parent" radio button
  prefClick(event) {
    if ($(event.currentTarget).data("more") == true) {
      $(".focus_area").prop("disabled", false);
    } else {
      $(".focus_area").prop("disabled", true).prop("checked", false);
    }
  }
}
